<template>
    <!-- 富文本编辑器,支持多图批量上传 -->
    <div>
        <el-dialog title="选择小程序" :visible.sync="dialogVisible" width="40%" :before-close="
                () => {
                    dialogVisible = false;
                }
            ">
            <div style="width: 100%; display: flex; align-items: center">
                <el-form :model="ruleForm" ref="ruleForm" label-width="100px" class="demo-ruleForm">
                    <el-form-item label="APPID" prop="weappId">
                        <el-input v-model="ruleForm.weappId" style="width: 200px"></el-input>
                    </el-form-item>

                    <el-form-item label="访问路径" prop="smallRouter">
                        <el-input v-model="ruleForm.smallRouter" style="width: 200px"></el-input>
                    </el-form-item>

                    <el-form-item label="展示方式" prop="methodStatus">
                        <el-radio-group v-model="ruleForm.methodStatus" style="width: 200px">
                            <el-radio :label="0">文字</el-radio>
                            <el-radio :label="1">图片</el-radio>
                            <!-- <el-radio :label="2">小程序卡片</el-radio> -->
                        </el-radio-group>
                    </el-form-item>

                    <el-form-item label="文字内容" prop="textValue" v-if="ruleForm.methodStatus == 0">
                        <el-input v-model="ruleForm.textValue" maxlength="100" style="width: 300px"></el-input>
                    </el-form-item>

                    <el-form-item label="卡片标题" prop="cardTitle" v-if="ruleForm.methodStatus == 2">
                        <el-input v-model="ruleForm.cardTitle" maxlength="100" style="width: 300px"></el-input>
                    </el-form-item>

                    <el-form-item :label="ruleForm.methodStatus == 1 ? '上传图片' : '卡片封面'" prop="textValue" v-if="ruleForm.methodStatus != 0">
                        <el-upload drag class="upload-demo" :headers="headers" :action="uploadImgUrl" name="file" :on-success="handleUploadSuccess" :before-upload="handleBeforeUpload" :on-error="handleUploadError" :show-file-list="false" accept="image/*">
                            <el-button type="primary" size="small" class="elcobut">添加图片</el-button>
                        </el-upload>

                        <!-- 上传图片展示 -->
                        <el-image v-if="ruleForm.weappImgUrl && ruleForm.methodStatus == 1" style="width: 200px; height: 200px" :src="ruleForm.weappImgUrl" :preview-src-list="[ruleForm.weappImgUrl]" :z-index="10010">
                        </el-image>

                        <!-- 上传封面图片展示 -->
                        <el-image v-if="ruleForm.weappCoverImgUrl && ruleForm.methodStatus == 2" style="width: 200px; height: 200px" :src="ruleForm.weappImgUrl" :preview-src-list="[ruleForm.weappImgUrl]" :z-index="10010">
                        </el-image>
                    </el-form-item>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="setSmallRoutine">确定</el-button>
            </span>
        </el-dialog>

        <quill-editor class="editor" ref="myTextEditor" v-model="content" :options="editorOption"></quill-editor>
        <el-upload ref="imageListUpload" class="select-uploader" hidden multiple :action="uploadImgUrl" :show-file-list="false" :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload" name="file" accept="image/*" :headers="headers">
            上传图片
        </el-upload>
    </div>
</template>

<script>
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
import clipboard from 'clipboard-all';
import { IMAGE_UPLOAD_OSS_URL } from '@/common/const.js';
import { quillEditor, Quill } from 'vue-quill-editor';
import ImageResize from 'quill-image-resize-module'; // 引用，调整图片大小

let BlockEmbed = Quill.import('blots/block/embed');
const Link = Quill.import('formats/link');
class ImageBlot extends BlockEmbed {
    static create(value) {
        let node = super.create();
        node.setAttribute('style', value.style);
        node.setAttribute('src', value.url);
        return node;
    }
    static value(node) {
        return {
            alt: node.getAttribute('style'),
            url: node.getAttribute('src')
        };
    }
}
ImageBlot.blotName = 'image';
ImageBlot.tagName = 'img';

Quill.register(ImageBlot, true); // 插入图片

Quill.register('modules/imageResize', ImageResize);

const toolbarOptions = [
    ['inweapp'],
    ['copyQuellEdtor'],
    ['bold', 'italic', 'underline', 'strike'], // toggled buttons
    ['blockquote', 'code-block'],

    [{ header: 1 }, { header: 2 }], // custom button values
    [{ list: 'ordered' }, { list: 'bullet' }],
    [{ script: 'sub' }, { script: 'super' }], // superscript/subscript
    [{ indent: '-1' }, { indent: '+1' }], // outdent/indent
    [{ direction: 'rtl' }], // text direction

    [{ size: ['small', false, 'large', 'huge'] }], // custom dropdown
    [{ header: [1, 2, 3, 4, 5, 6, false] }],

    [{ color: [] }, { background: [] }], // dropdown with defaults from theme
    [{ font: [] }],
    [{ align: [] }],
    ['image', 'video', 'link'],
    ['clean'] // remove formatting button
];

export default {
    name: 'quellEditor',
    components: {
        quillEditor
    },

    props: {
        detailContent: {
            type: String,
            default: ''
        },
        center: {
            type: String,
            default: '',
        }
    },

    data() {
        return {
            loadingpush: null,
            dialogVisible: false,
            content: '',
            uploadImgUrl: IMAGE_UPLOAD_OSS_URL, // 上传的图片服务器地址
            headers: {
                Authorization: localStorage.getItem('middle-token')
            },

            ruleForm: {
                weappId: null, // 小程序appid
                textValue: '', // 文字内容
                smallRouter: '', // 小程序路径
                weappImgUrl: '', // 上传图片路径
                weappCoverImgUrl: '', // 上传封面
                cardTitle: '', // 卡片标题
                methodStatus: 0 // 展示方式 0：文字， 1：图片 2： 卡片
            },

            editorOption: {
                placeholder: '请输入',
                content: this.content,
                modules: {
                    toolbar: {
                        container: toolbarOptions, // 工具栏
                        handlers: {
                            image: function(value) {
                                if (value) {
                                    // document.querySelector('#detail-img').click()
                                    document.querySelector('.select-uploader input').click();
                                } else {
                                    this.quill.format('image', false);
                                }
                            },

                            inweapp: this.showHandle,
                            copyQuellEdtor: this.showCopyQuellEdtor
                        }
                    },
                    imageResize: {
                        displayStyles: {
                            backgroundColor: 'black',
                            border: 'none',
                            color: 'white'
                        },
                        modules: ['Resize', 'DisplaySize', 'Toolbar']
                    }
                },
                // formats: toolbarOptions,
            },
            isloginTo: true,
        };
    },

    watch: {
        content(val) {
            this.$emit('update:detailContent', val);
        },

        detailContent(val) {

            if (this.isloginTo) {
                this.isloginTo = false;
                this.$refs.myTextEditor.quill.container.querySelector(
                    // 渲染到富文本框
                    '.ql-editor'
                ).innerHTML = val;
            } else {
                this.content = val;
            }
        },
    },

    mounted() {
        this.initButton();

        let quill = this.$refs.myTextEditor.quill;
        quill.format('link', { href: true, target: '_blank' });

    },

    created() {

    },

    methods: {
        // 自定义按钮内容初始化
        initButton() {
            const editorButton = document.querySelector('.ql-inweapp');
            editorButton.innerHTML = '小程序';

            const editorButtonY = document.querySelector('.ql-copyQuellEdtor');
            editorButtonY.innerHTML = '复制富文本框';
        },

        // 添加小程序
        showHandle() {
            this.ruleForm = {
                weappId: null, // 小程序appid
                textValue: '', // 文字内容
                smallRouter: '', // 小程序路径
                weappImgUrl: '', // 上传图片路径
                methodStatus: 0 // 展示方式 0：文字， 1：图片 2： 卡片
            };
            // this.$message.error("这是自定义工具栏的方法！");
            this.dialogVisible = true;
        },

        // 复制富文本框方法
        async showCopyQuellEdtor() {
            let element = this.$refs['myTextEditor'].quill.container;
            console.log(element, 'element');
            let res = await clipboard(element);
            if (res) {
                this.$message.success('复制成功');
                // console.log("复制成功");
            }
        },

        // 确定添加
        setSmallRoutine() {
            let that = this;
            let text = '';
            if (this.ruleForm.methodStatus == 0) {
                // 若是文字类型   则渲染a标签中添加文字
                text = `<p><a class="weapp_text_link js_weapp_entry" style="font-size:medium;" data-miniprogram-appid="${this.ruleForm.weappId}" data-miniprogram-path="${this.ruleForm.smallRouter}" data-miniprogram-nickname="鲤好惠选" href="test" data-miniprogram-type="text" data-miniprogram-servicetype="">${this.ruleForm.textValue}</a></p>`;
            }

            if (this.ruleForm.methodStatus == 1) {
                // 若是图片类型   则渲染a标签中添加图片
                text = `<p><a class="weapp_image_link js_weapp_entry" style="font-size:medium;" data-miniprogram-appid="${this.ruleForm.weappId}" data-miniprogram-path="${this.ruleForm.smallRouter}" data-miniprogram-nickname="鲤好惠选" href="test" data-miniprogram-type="text" data-miniprogram-servicetype=""><img data-s="300,640" class="rich_pages wxw-img" src="${this.ruleForm.weappImgUrl}" style="" data-type="jpeg" data-imgqrcoded="1" data-ratio="1" data-w="800" /></a></p>`;
            }
            console.log('富文本', text);



            // let index = this.$refs.myTextEditor.quill.selection.savedRange.index; //获取富文本中光标位置
            // let quill = that.$refs.myTextEditor.quill;
            // quill.clipboard.dangerouslyPasteHTML(index, text);


            let html = '';
            if (this.$refs.myTextEditor._content) {
                // 获取当前富文本框中的内容  将已经输入的内容跟小程序内容合并
                html = this.$refs.myTextEditor._content + text;
            } else {
                html = text;
            }
            // 编辑时进行文本框赋值
            this.$refs.myTextEditor.quill.container.querySelector(
                // 渲染到富文本框
                '.ql-editor'
            ).innerHTML = html;



            setTimeout(() => {
                // 获取富文本组件实例
                let quill = that.$refs.myTextEditor.quill;
                // 获取光标所在位置
                let length = quill.selection.savedRange.index;
                // 调整光标到最后
                quill.setSelection(length + 1);
            }, 200);

            this.ruleForm = {
                // 重置输入内容
                weappId: null, // 小程序appid
                textValue: '', // 文字内容
                smallRouter: '', // 小程序路径
                weappImgUrl: '', // 上传图片路径
                methodStatus: 0 // 展示方式 0：文字， 1：图片 2： 卡片
            };

            this.dialogVisible = false; // 关闭弹窗
        },

        //图片上传
        handleAvatarSuccess(res, file, fileList) {
            let len = fileList.length;
            let successCount = 0;
            for (let file of fileList) {
                if (file.status === 'success') {
                    successCount += 1;
                    this.loadingpush.close();
                } else {
                    break;
                }
            }

            if (len === successCount) {
                this.$refs.imageListUpload && this.$refs.imageListUpload.clearFiles();
                for (let file of fileList) {
                    // 获取富文本组件实例
                    let quill = this.$refs.myTextEditor.quill;
                    // 获取光标所在位置
                    let length = quill.getSelection().index;
                    // quill.insertEmbed(length, 'image', res.data.uri)
                    quill.insertEmbed(length, 'image', {
                        style: 'display:block;',
                        url: file.response.data.uri
                    });
                    // 调整光标到最后
                    quill.setSelection(length + 1);
                }
            }
        },

        beforeAvatarUpload(file) {
            this.loadingpush = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            // loads.open('.avatar-uploader .el-upload', '上传中')
            const _this = this;
            return this.imageFormat(file, _this, 300);
        },

        getDetailImg(urlList) {
            // 获取富文本组件实例
            let quill = this.$refs.myTextEditor.quill;
            for (let url of urlList) {
                // 获取光标所在位置
                let length = quill.getSelection().index;

                // 插入图片  res.info为服务器返回的图片地址
                quill.insertEmbed(length, 'image', url);

                // 调整光标到最后
                quill.setSelection(length + 1);
            }

            this.detailImgVisible = false;
        },

        imageFormat(file, _this, size = 300) {
            console.log(size);
            console.log(3333, file.type);
            const isIMG = file.type === 'image/jpg' || file.type === 'image/jpeg' || file.type === 'image/png';
            const isLt = file.size / 1024 <= size;
            if (!isIMG) {
                _this.$message.error('上传图片只支持jpg、jpeg、png格式!');
                return false;
            }
            /*if (!isLt) {
                  _this.$message.error(`上传图片大小不能超过${size}KB!`)
                  return false
              }*/
        },

        handleUploadSuccess(res) {
            this.loading.close();
            console.log(res, 'img');
            this.ruleForm.weappImgUrl = res.data.uri;
            // OrderSendImportExcel({file: res.data[0].url}).then(res => {
            // 	if(res.code == 0){
            // this.msgSuccess("导入成功");

            // 	}
            // })
        },
        handleBeforeUpload() {
            this.loading = this.$loading({
                lock: true,
                text: '上传中',
                background: 'rgba(0, 0, 0, 0.7)'
            });
        },
        handleUploadError() {
            this.$message({
                type: 'error',
                message: '上传失败'
            });
            this.loading.close();
        }
    }
};
</script>

<style scoped>
/* 文本编辑样式 */
.editor {
    width: 60%;
    height: 600px;
}
.editor >>> .ql-container {
    min-height: 300px;
}
.ql-snow .ql-editor img {
    display: block !important;
}

/deep/ .weapp_text_link::before {
    content: '';
    display: inline-block;
    line-height: 1;
    background-size: 12px 12px;
    background-repeat: no-repeat;
    background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAMAAABF0y+mAAAAb1BMVEUAAAB4it11h9x2h9x2h9x2htx8j+R8i+B1h9x2h9x3h92Snv91htt2h9x1h9x4h9x1h9x1h9x2idx1h9t2h9t1htt1h9x1h9x1htx2h9x1h912h9x4h913iN17juOOjuN1iNx2h9t4h958i+B1htvejBiPAAAAJHRSTlMALPLcxKcVEOXXUgXtspU498sx69DPu5+Yc2JeRDwbCYuIRiGBtoolAAAA3ElEQVQoz62S1xKDIBBFWYiFYImm2DWF///G7DJEROOb58U79zi4O8iOo8zuCRfV8EdFgbYE49qFQs8ksJInajOA1wWfYvLcGSueU/oUGBtPpti09uNS68KTMcrQ5jce4kmN/HKn9XVPAo702JEdx9hTUrWUqVrI3KwUmM1NhIWMKdwiGvpGMWZOAj1PZuzAxHwhVSplrajoseBnbyDHAwvrtvKKhdqTtFBkL8wO5ijcsS3G1JMNvQ5mdW7fc0x0+ZcnlJlZiflAomdEyFaM7qeK2JahEjy5ZyU7jC/q/Rz/DgqEuAAAAABJRU5ErkJggg==);
    vertical-align: middle;
    font-size: 11px;
    color: #888;
    border-radius: 10px;
    background-color: #f4f4f4;
    margin-right: 6px;
    margin-top: -4px;
    background-position: center;
    height: 20px;
    width: 20px;
}

/deep/ .weapp_image_link::after {
    content: ' ';
    width: 26px;
    height: 26px;
    display: block;
    position: absolute;
    top: 9px;
    right: 9px;
    background: url(data:image/png;base64,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)
        no-repeat center;
    background-size: contain;
    position: absolute;
    right: 20px;
    top: 20px;
}

/deep/ .weapp_text_link {
    color: #576b95;
    font-size: 0;
    display: inline-block;
    position: relative;
    vertical-align: bottom;
    text-decoration: none !important;
}

/deep/ .weapp_image_link {
    font-size: 0;
    display: inline-block;
    position: relative;
    vertical-align: bottom;
}

/deep/ .ql-inweapp {
    width: auto !important;
}

/deep/ .ql-copyQuellEdtor {
    width: auto !important;
}

/deep/ .wxw-img {
    vertical-align: bottom !important;
}

/deep/.el-upload-dragger {
    border: none !important;
    width: auto !important;
    height: auto !important;
}

.el-upload-list {
    display: none !important;
}
.demo-ruleForm {
    width: 100%;
}
</style>
